(function () {

    'use strict';

    /**
     * Initiates the details.
     */
    const Accordion = function (element) {

        this.element = element;
        this.details = element.getElementsByClassName('accordion__detail');
        this.covers = element.getElementsByClassName('accordion__cover');

        this.toggleState = this.toggleState.bind(this);
        this.startAnimation = this.startAnimation.bind(this);
        this.stopAnimation = this.stopAnimation.bind(this);
        this.resetAnimation = this.resetAnimation.bind(this);
        this.resetView = this.resetView.bind(this);

        this.interval = null;

        this.initiateListener();
    }

    /**
     * Initiates the listener.
     */
    Accordion.prototype.initiateListener = function () {

        this.element.addEventListener('pointerdown', this.toggleState);
        this.element.addEventListener('keyup', this.toggleState);

        const observer = new IntersectionObserver(function (entries) {

            entries.forEach(function (entry) {

                if (entry.isIntersecting) {
                    this.selectNext(1);

                } else {
                    this.resetView(); // ...when leaving the area
                }

            }.bind(this));

        }.bind(this));

        observer.observe(this.element);
    }

    /**
     * Resets the whole view.
     */
    Accordion.prototype.resetView = function () {

        for (let index = 0; index < this.details.length; index++) {

            let detail = this.details[index];
            let cover = this.covers[index];

            let button = detail.firstElementChild;
            let bar = detail.lastElementChild;

            if (index === 0) {
                button.setAttribute('aria-selected', 'true');
                button.setAttribute('tabindex', '-1');
                cover.classList.add('accordion__cover--open');

            } else {
                button.setAttribute('aria-selected', 'false');
                button.removeAttribute('tabindex');
                cover.classList.remove('accordion__cover--open');
            }

            bar.firstElementChild.setAttribute('width', '0%'); // Rectangle
        }

        this.resetAnimation()
    }

    /**
     * Toggles the state.
     */
    Accordion.prototype.toggleState = function (event) {

        if (event.target.tagName === 'BUTTON') {

            this.resetAnimation();

            this.selectNext(Number(event.target.dataset.index));
        }
    }

    /**
     * Selects the next.
     */
    Accordion.prototype.selectNext = function(index) {

        for (const detail of this.details) {

            let button = detail.firstElementChild;
            let bar = detail.lastElementChild;

            if (Number(button.dataset.index) === index) {

                button.setAttribute('aria-selected', 'true');
                button.setAttribute('tabindex', '-1');

                this.startAnimation(bar.firstElementChild, function () {

                    if (index >= this.details.length) {
                        index = 1;

                    } else {
                        index = index + 1;
                    }

                    this.selectNext(index)

                }.bind(this));

            } else {
                button.setAttribute('aria-selected', 'false');
                button.removeAttribute('tabindex');

                bar.firstElementChild.setAttribute('width', '0%'); // Rectangle
            }
        }

        for (const cover of this.covers) {

            if (Number(cover.dataset.index) === index) {
                cover.classList.add('accordion__cover--open');

            } else {
                cover.classList.remove('accordion__cover--open');
            }
        }
    }

    /**
     * Starts the animation.
     */
    Accordion.prototype.startAnimation = function (target, onComplete) {

        let progress = 1;

        this.interval = setInterval(function animate() {

            if (progress >= 100) {

                this.resetAnimation();

                onComplete();

            } else {

                progress += 0.5;

                target.setAttribute('width', progress + '%');
            }

        }.bind(this), 30)
    }

    /**
     * Resets the animation.
     */
    Accordion.prototype.resetAnimation = function () {

        clearInterval(this.interval);

        this.interval = null;
    }

    Accordion.prototype.stopAnimation = function(event) {

        if (event.target.classList.contains('accordion__detail')) {

            let button = event.target.firstElementChild;

            if (button.ariaSelected) {

                if (this.interval !== null) {
                    clearInterval(this.interval);
                }
            }
        }
    }

    const accordions = document.getElementsByClassName('js-accordion');

    for (const accordion of accordions) {
        new Accordion(accordion);
    }
}());